import { Form, useFormikContext } from 'formik'
import { Typography } from '@mui/material'

import { HelperWrapper } from 'src/components'

import { useStyles } from './styles'
import { AccountSwitchButton } from './accaunt-switch'
import {
  EDefaultLandingPage,
  IAccountJourneySettings,
  IUpdateAccountJourneySettingsDto,
} from 'src/types'
import { DefaultLandingPageSettings } from './default-landing-page-settings'

interface IProps {
  mobile?: boolean
  handleSubmit: (values: IUpdateAccountJourneySettingsDto) => void
}

export const SwitchListComponent = ({ mobile, handleSubmit }: IProps) => {
  const { isSubmitting, values, setFieldValue } = useFormikContext<IAccountJourneySettings>()

  const classes = useStyles({ mobile })

  const handleChange = (name: string, checked: boolean) => {
    setFieldValue(name, checked)
    handleSubmit({ [name]: checked })
  }

  const handleDefaultLandingPageChange = (value: EDefaultLandingPage) => {
    if (values.default_landing_page !== value) {
      setFieldValue('default_landing_page', value)
      handleSubmit({ default_landing_page: value })
    }
  }

  return (
    <Form className={classes.settingsItems} style={!mobile ? { paddingLeft: '15px' } : {}}>
      {!mobile && (
        <h3 className={classes.itemSubtitle}>
          <HelperWrapper t="account-journey-page-settings-label" />
        </h3>
      )}
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="hide_name"
          disabled={isSubmitting}
          checked={values.hide_name}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-hide-name-switch-label" />}
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="hide_product_name"
          disabled={isSubmitting}
          checked={values.hide_product_name}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-hide-product-name-switch-label" />}
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="map_satellite_view"
          disabled={isSubmitting}
          checked={values.map_satellite_view}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-map-view-switch-label" />}
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="show_wallet_address"
          disabled={isSubmitting}
          checked={values.show_wallet_address}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-wallet-address-switch-label" />}
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="show_bc_info"
          disabled={isSubmitting}
          checked={values.show_bc_info}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-show-bc-info-switch-label" />}
        />
      </div>

      <Typography variant="h4" fontSize={15} fontWeight={600}>
        <HelperWrapper t="account-settings-unsgd-icons-lable" />
      </Typography>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="show_unsgd_home_page"
          disabled={isSubmitting}
          checked={values.show_unsgd_home_page}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-show-unsgd-home-switch-label" />}
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="show_unsgd_impacts_page"
          disabled={isSubmitting}
          checked={values.show_unsgd_impacts_page}
          handleChange={handleChange}
          lable={<HelperWrapper t="account-settings-show-unsgd-impacts-switch-label" />}
        />
      </div>
      <DefaultLandingPageSettings mobile={mobile} handleChange={handleDefaultLandingPageChange} />
    </Form>
  )
}
